import { z } from 'zod';
import { Member } from './member.model';
import { TenantMembership } from './tenant-membership.model';

export const Account = z.object({
  id: z.uuidv4(),
  email: z.email(),
  created_at: z.iso.datetime(),
});

export type Account = z.infer<typeof Account>;

// Response from /auth/current-account/ describing who is signed in:
// - account: the global identity shared across tenants, holding login and
//   email. Always present.
// - membership: grants access to the current tenant and holds the user's
//   role. The single source of truth for permissions.
// - member: the tenant-scoped record that quotes, CAD files, etc. are
//   attributed to (e.g. as creator/owner).
// membership and member are only returned on tenant hosts; on the public
// (admin) host only the account is present.
export const CurrentAccountResponse = z.object({
  account: Account,
  membership: TenantMembership.optional(),
  member: Member.optional(),
});

export type CurrentAccountResponse = z.infer<typeof CurrentAccountResponse>;
